// extracted by mini-css-extract-plugin
export var Aside = "ToggleMode-module--Aside--f47a7";